/**
 * Company analytics dashboard format (SA-1849).
 *
 * Sourced from GET /me `analytic_setting.analytic_type` and written by the
 * super-admin company detail form. Lives in `shared/` because `features/claim`
 * reads it to pick a summary-card variant while `features/management` writes it
 * — hosting it in either feature would force a cross-feature import.
 */
export const ANALYTIC_TYPE = {
  DEFAULT: 'DEFAULT',
  ZAI_DASHBOARD: 'ZAI_DASHBOARD',
};
